import * as React from "react";
const SvgChevronFillUp = (props) => /* @__PURE__ */ React.createElement("svg", props, /* @__PURE__ */ React.createElement("path", { d: "M33.309 29.341H6.69c-2.393 0-3.59-2.896-1.9-4.585l13.308-13.309a2.673 2.673 0 0 1 3.791 0l13.32 13.309c1.688 1.689.492 4.585-1.901 4.585Z" }));
export default SvgChevronFillUp;
